__webpack_require__.p = "/interactive/regeneron/global-future-of-stem/ja/";